import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment} from '@api'
import {Menu, MenuDivider} from '@blueprintjs/core'
import {Popover2, Tooltip2} from '@api'
import {TabSetNode} from '@flexlayout'
import {CatalogTabMenuItems, ContextMenuItem, NewFlexTabMenuItems, useVipLocalStore, VipLocalStore} from '@modules'
import {CatalogRootFlexLayoutStoreContext, StoresInstance} from '@stores'
import {VipFlexLayoutTabStoreContext} from '@stores/catalog/flexLayout'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './ChooseTabOnTabSetDropdownMenuButton.css'

/// region Store

export class ChooseTabOnTabSetDropdownMenuButtonStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable foo = false

  @computed get bar() { return null }

  @action verb = () => {}
}

export const ChooseTabOnTabSetDropdownMenuButtonStoreContext = React.createContext<ChooseTabOnTabSetDropdownMenuButtonStore>(null)
export const useChooseTabOnTabSetDropdownMenuButtonStore = () => React.useContext(ChooseTabOnTabSetDropdownMenuButtonStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const ChooseTabOnTabSetDropdownMenuButton = observer<{ tabSet: TabSetNode }>(function ChooseTabOnTabSetDropdownMenuButton({tabSet}) {
  const {tabs} = tabSet

  return (
    <Popover2
      interactionKind='hover'
      position='bottom-right'
      minimal
      className={css.root}
      content={<Menu>
        <ContextMenuItem icon='key-tab' text='New Tab...'>
          <NewFlexTabMenuItems/>
        </ContextMenuItem>

        {_.isEmpty(tabs) ?
         <Fragment>
         </Fragment> :
         <Fragment>
           <MenuDivider title={`Tabs (${tabs.length})`}/>
           {tabs.map(tab => <ContextMenuItem key={tab.id}
                                             className={css.flexTabMenuItem}
                                             text={tab.displayName}
                                             active={tab.isSelected}
                                             // labelElement={<div>
                                             //   <PrimaryIconButton icon='cross' tooltip='Close Tab' tooltipPosition='bottom' onClick={() => tab.removeFromParent()}/>
                                             // </div>}
                                             onClick={() => tab.selectInTabSet()}>
             <VipFlexLayoutTabStoreContext.Provider value={tab.vipTabStore}>
               <CatalogRootFlexLayoutStoreContext.Provider value={tab.catalogRoot}>
                 <CatalogTabMenuItems/>
               </CatalogRootFlexLayoutStoreContext.Provider>
             </VipFlexLayoutTabStoreContext.Provider>
           </ContextMenuItem>)}
           <MenuDivider/>
           {tabSet.children.length > 1 && <ContextMenuItem icon='trash' text={`Close Other Tabs in this Group (${tabSet.children.length - 1})`} onClick={() => tabSet.removeAllButSelectedTab()}/>}
           <ContextMenuItem icon='trash' text='Close All Tabs in this Group' onClick={() => tabSet.removeFromParent()}/>
         </Fragment>}
      </Menu>}
    >
      <PrimaryIconButton
        icon='caret-down'
        tooltip='Manage Tabs' tooltipPosition='bottom'
      />
    </Popover2>
  )
})
//
// export const ChooseTabOnTabSetDropdownMenuButton = observer<MyProps>(function ChooseTabOnTabSetDropdownMenuButton({className, ...props}) {
//   const obsProps = useAsObservableSource({props}),
//     store = useVipLocalStore((stores) => new ChooseTabOnTabSetDropdownMenuButtonStore(stores, obsProps)),
//     {} = store
//
//   useEffect(() => store.registerEffects(), [])
//
//   return (
//     <ChooseTabOnTabSetDropdownMenuButtonStoreContext.Provider value={store}>
//       <div className={classNames(css.root, className)}>
//
//       </div>
//     </ChooseTabOnTabSetDropdownMenuButtonStoreContext.Provider>)
// })

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/ChooseTabOnTabSetDropdownMenuButton.tsx